import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Shift } from '../../models/shift';
import { ShiftSettingsService } from '../../shift-settings.service';
import * as shiftSettingsActions from '../actions';

@Injectable()
export class ShiftSettingsEffects {
  @Effect()
  public loadShiftSettings$ = this.actions$.pipe(
    ofType<shiftSettingsActions.GetShiftSettings>(
      shiftSettingsActions.GET_SHIFT_SETTINGS
    ),
    switchMap(() =>
      this.shiftSettingsService.getShifts().pipe(
        map(
          (shifts: Array<Shift>) =>
            new shiftSettingsActions.GetShiftSettingsSuccess(shifts)
        ),
        catchError((error: any) =>
          of(new shiftSettingsActions.GetShiftSettingsFail(error))
        )
      )
    )
  );

  @Effect()
  public deleteShift$ = this.actions$.pipe(
    ofType<shiftSettingsActions.DeleteShift>(shiftSettingsActions.DELETE_SHIFT),
    switchMap((action: any) =>
      this.shiftSettingsService.deleteShift(action.payload).pipe(
        map(
          (shiftsToKeep: Array<Shift>) =>
            new shiftSettingsActions.DeleteShiftSuccess(shiftsToKeep)
        ),
        catchError((error: any) =>
          of(new shiftSettingsActions.DeleteShiftFail(error))
        )
      )
    )
  );

  @Effect()
  public addShift$ = this.actions$.pipe(
    ofType<shiftSettingsActions.AddShift>(shiftSettingsActions.ADD_SHIFT),
    switchMap((action: any) =>
      this.shiftSettingsService.addShift(action.payload).pipe(
        map(
          (updatedShifts: Array<Shift>) =>
            new shiftSettingsActions.AddShiftSuccess(updatedShifts)
        ),
        catchError((error: any) =>
          of(new shiftSettingsActions.AddShiftFail(error))
        )
      )
    )
  );

  @Effect()
  public editShift$ = this.actions$.pipe(
    ofType<shiftSettingsActions.EditShift>(shiftSettingsActions.EDIT_SHIFT),
    switchMap((action: any) =>
      this.shiftSettingsService.editShift(action.payload).pipe(
        map(
          (updatedShifts: Array<Shift>) =>
            new shiftSettingsActions.EditShiftSuccess(updatedShifts)
        ),
        catchError((error: any) =>
          of(new shiftSettingsActions.EditShiftFail(error))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private shiftSettingsService: ShiftSettingsService
  ) {}
}
